import { createContext, useContext } from "react";

/** The shell's floating parts, opened from anywhere: the top bar, the More sheet, Help. */
export interface ShellValue {
  /** False outside the app shell (the phone approval screen), where these can't open. */
  available: boolean;
  /** Search and commands; `query` starts it with words already typed. */
  openPalette: (query?: string) => void;
  /** The keyboard shortcuts overlay. */
  openShortcuts: () => void;
}

export const ShellContext = createContext<ShellValue>({
  available: false,
  openPalette: () => undefined,
  openShortcuts: () => undefined,
});

export const useShell = () => useContext(ShellContext);
